import store from '@/stores';
import { UserActions } from '@/stores/slice/user';
import { openPointsDialog } from './';


/**
 * 检查用户金币是否足够
 * !! 注意，这个方法是有副作用的
 * @returns {true} true 足够，本地删除金币，并进行后续
 * @returns {false} true 不足，会弹窗
 */
export const checkHasPoints = (pointCount: number, onClose?: () => void, configs?: {
  /** 为true时，运行没有扣points的副作用 */
  checkOnly?: boolean;
}): boolean => {
  const points = store.getState().user.userPermission.points || 0;
  const isVip = store.getState().user.userPermission.isVip;
  const { checkOnly = false } = configs || {};
  console.info('当前金币', points, '需要金币', pointCount);
  if (pointCount <= points || isVip) {
    if (pointCount > 0 && !checkOnly) {
      store.dispatch(UserActions.subtrackPointsLocal(pointCount));
    }
    return true;
  }
  // input 键盘提交时，无法同步唤起弹窗
  requestAnimationFrame(() => {
    openPointsDialog({ requiredPoints: pointCount, ownPoints: points, onClose });
  });
  return false;
};

export const checkUserPointsOnly = (pointCount: number): boolean => { 
  const points = store.getState().user.userPermission.points || 0;
  const isVip = store.getState().user.userPermission.isVip;
  if (pointCount <= points || isVip) {
    return true;
  }
  return false;
};
